import { useState } from 'react'
import Toast from '@components/Toast/Toast'

export const useToast = () => {
  const [message, setMessage] = useState('')

  const showToast = (msg: string) => setMessage(msg)

  const toastElement = message && (
    <Toast message={message} onClose={() => setMessage('')} />
  )

  return { showToast, toastElement }
}
